import React from "react";
import { Redirect } from "react-router-dom";

const ErrorMessage = (props) => {
  const error = props.error;
  const status = error ? error.status : null;
  const data = error ? error.data : null;
  const tokenRefreshFail = data ? data.isRefreshTokenFail : false;

  if (!error) {
    return <div style={{ color: "red" }}>'Error 404'</div>;
  }

  if (tokenRefreshFail) return <Redirect to="/login" />;

  if (!data || !data.messages || data.messages.length === 0)
    return (
      <div style={{ color: "red" }}>{"Internal server error " + status}</div>
    );

  function rowStyle(category) {
    switch (category) {
      case 1:
        return { color: "red" };
      case 2:
        return { color: "blue" };
      case 3:
        return { color: "green" };
      default:
        return { color: "black" };
    }
  }
  const listRender = () => (
    <ul>
      {data &&
        data.messages &&
        data.messages.map((m, i) => (
          <li key={i} style={rowStyle(m.category)}>
            <div>{m.message}</div>
          </li>
        ))}
    </ul>
  );

  return listRender();
};
export default ErrorMessage;
